import React from "react";
// import Botdetail from "../../botDetailEndUser/index";
import { connect } from "react-redux";
import { useRouter } from 'next/router'
import styles from "../../../styles/pages/botStore.module.scss";
import { imageBaseURL } from "../../../data/createBotForm";

function index(props) {


  const router = useRouter()

  const [currentBot, setCurrentBot] = React.useState(null)





  React.useEffect(() => {
    setCurrentBot(props.currentBot)
  }, [props.currentBot])



  React.useEffect(() => {
    console.log(router.query, "all kinda queries")
  }, [router.query])



  return (
    <div>
       <div className="container h-100">
        <div className="row  mt-5">
            <div className="col-md-6 col-12">
                <div className={styles.crard_main_section}>
                    <div className="d-flex align-items-center mb-3 mt-4">
                    <img src={`${imageBaseURL}product10.svg`} alt=""  className="mr-2"/><h1 style={{fontWeight:"600"}}>Neo</h1>
                    </div>
                    <div className={styles.card_section1}>
                        <div className="mb-3">
                            <img src={`${imageBaseURL}maps.svg`} alt="" className="mr-2" />
                            <span>Clusters Live</span>
                        </div>
                        <p>South Africa</p>
                    </div>
                    <p className="crard_main_section_p">With our Neo product the order capturng is fully automated, all the PDFs/ Excels / Images sent via mail have automated extraction of data.</p>
                </div>
                <div className={styles.blue_card_section}>  
                    <div className="d-flex align-items-center justify-content-center">
                        <div className=" mr-4" >
                            <h1>45000+</h1>
                            <p>Man Hours Saved</p>
                        </div>
                    </div> 
                </div>
            </div>
            <div className="col-md-6 col-12 mt-auto">
                 <div className={styles.iframe_section}>
                    <img src={`${imageBaseURL}productneo.png`} width="100%" height={345}/>
                 </div>
            </div>
        </div>
       </div>
       <div className={styles.benefits_section}>
            <div className="container h-100">
                <div  className="mb-5">
                <h1>Top Benefits</h1>
                </div>
                <div className={styles.Frist_section}>
                <div className="row ">
                    <div className="col-md-3 col-6  mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits.svg`} alt="" />
                            <p>Accurate process</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits1.svg`} alt="" />
                            <p>Manual efforts saved</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits2.svg`} alt="" />
                            <p>Full automated solution</p>
                        </div>
                    </div>
                    <div className="col-md-3 col-6 mb-4 mb-md-0">
                        <div className={styles.cards_benefits}>
                            <img src={`${imageBaseURL}benifits3.svg`} alt="" />
                            <p>Real time insigts for orders processed</p>
                        </div>
                    </div>
                </div>
                </div>
                <div className="row">
                    <div className="col-md-6 ">
                        <div  className={`text-center position-relative ${styles.cards_benefits_card}`}>
                         <img src={`${imageBaseURL}robo.png`} alt="" />
                            <div className="back_image">
                                <img src={`${imageBaseURL}dot.svg`} className={styles.img_1} alt="" />
                                <img src={`${imageBaseURL}dot1.svg`} className={styles.img_2} alt="" />
                                <img src={`${imageBaseURL}dot2.svg`} className={styles.img_3} alt="" />

                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <h2 className="mb-5" style={{fontWeight:"600"}}>Process</h2>
                        {/* <p className="mb-4">1,000s of invoices left to be updated! Don’t worry, we can help your team colate & update invoices on your behalf.</p> */}
                        <ol>
                            <li >
                                <div>
                                    <p>Customers send mail to Neo id</p>
                                </div>
                            </li>
                            <li >
                                    <div>
                                        <p>
                                        Abby (OCR Tool) extracts all informations from the documents send 
                                        </p>
                                    </div>
                                </li>
                            <li >
                                <div>
                                    <p>From there the format is converted to EDIFACT</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <p>This is then sent to Dell Boomi (The middleware)</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <p>And Dell Boomi processes towards SAP</p>
                                </div>
                            </li>
                            <li >
                                <div>
                                    <p>Once this is processed all order status are sent to the Dashboards</p>
                                </div>
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
  );
}

export default index;
